import { useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import aplikasiwebpertama2 from "../assets/aplikasiwebpertama2.png";
import dataImage from "../assets/data2.png";
import mobileImg from "../assets/mobiledev.png";
import dataanalytics2 from "../assets/dataanalytics2.png";
import datascience2 from "../assets/datascience2.png";
import firstcode from "../assets/firstcode.png";

const courses = [
  {
    title: 'Membuat Aplikasi berbasis Web Pertamaku',
    price: '150k',
    rating: 5,
    review: 18,
    image: aplikasiwebpertama2,
  },
  {
    title: 'Belajar Data dari Dasar',
    price: '150k',
    rating: 5,
    review: 9,
    image: dataImage,
  },
  {
    title: 'Pengembangan Aplikasi Mobile menggunakan Flutter',
    price: '150k',
    rating: 4,
    review: 5,
    image: mobileImg,
  },
  {
    title: 'Data Analytics',
    price: '150k',
    rating: 5,
    review: 12,
    image: dataanalytics2,
  },
  {
    title: 'Data Science',
    price: '150k',
    rating: 5,
    review: 22,
    image: datascience2,
  },
  {
    title: 'Menulis Kode Pertamaku',
    price: '150k',
    rating: 5,
    review: 15,
    image: firstcode,
  },
];

const CourseSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const cardPerView = 3;
  const totalSlides = Math.ceil(courses.length / cardPerView);
  const intervalRef = useRef(null);

  const chunkCourses = [];
  for (let i = 0; i < courses.length; i += cardPerView) {
    chunkCourses.push(courses.slice(i, i + cardPerView));
  }

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const handleDotClick = (index) => {
    setCurrentSlide(index);
    clearInterval(intervalRef.current);
  };

  useEffect(() => {
    intervalRef.current = setInterval(nextSlide, 5000);
    return () => clearInterval(intervalRef.current);
  }, []);

  return (
    <div className="relative  max-w-6xl mx-auto px-0 pb-3">
        <h2 className="text-3xl font-bold mb-3">Kursus Populer</h2>
      {/* Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow z-10"
      >
        <ChevronLeft />
      </button>

      <div className="overflow-hidden w-full">
        <div
          className="flex transition-transform duration-700 ease-in-out"
          style={{
            width: `${totalSlides * 100}%`,
            transform: `translateX(-${currentSlide * (100 / totalSlides)}%)`,
          }}
        >
          {chunkCourses.map((group, idx) => (
            <div key={idx} className="w-full flex justify-between px-1">
              {group.map((course, index) => (
                <div key={index} className="w-1/3 px-3 box-border">
                  <div className="bg-white p-4 rounded-xl shadow h-full flex flex-col">
                    <img
                      src={course.image}
                      alt={course.title}
                      className="rounded-lg h-40 w-full object-cover mb-4"
                    />
                    <h3 className="font-semibold text-md mb-2 line-clamp-2">{course.title}</h3>
                    <div className="flex items-center text-yellow-500 mb-2 text-sm">
                      {'★'.repeat(course.rating)}{'☆'.repeat(5 - course.rating)}
                      <span className="text-gray-600 ml-2">({course.review})</span>
                    </div>
                    <div className="mt-auto text-green-600 font-semibold"> Start
                      Rp{course.price}
                      <span className="text-gray-500">/session</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Arrow kanan */}
      <button
        onClick={nextSlide}
        className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow z-10"
      >
        <ChevronRight />
      </button>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-6">
        {chunkCourses.map((_, idx) => (
          <div
            key={idx}
            onClick={() => handleDotClick(idx)}
            className={`w-4 h-2 rounded-full cursor-pointer ${
              idx === currentSlide ? 'bg-teal-600' : 'bg-gray-300'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default CourseSection;
